import { render, staticRenderFns } from "./PropertyMaintenanceJobDetail.vue?vue&type=template&id=1bc3737a"
import script from "./PropertyMaintenanceJobDetail.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceJobDetail.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceJobDetail.vue?vue&type=style&index=0&id=1bc3737a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports